// extracted by mini-css-extract-plugin
module.exports = {"why-learnhat":"WhyLearnhat_why-learnhat__2O8jL","why-learnhat__heading":"WhyLearnhat_why-learnhat__heading__t5aDf","why-learnhat__cards":"WhyLearnhat_why-learnhat__cards__2OJ48"};